export const ENV_VAR = {
  NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET,

  // NEXTAUTH_URL: process.env.NEXTAUTH_URL,
  AZURE_AD_CLIENT_ID: process.env.AZURE_AD_CLIENT_ID,
  AZURE_AD_CLIENT_SECRET: process.env.AZURE_AD_CLIENT_SECRET,
  AZURE_AD_TENANT_ID: process.env.AZURE_AD_TENANT_ID,
  API_URL: process.env.API_URL || '',
  STRAPI_URL: process.env.STRAPI_URL || '',
  STRAPI_TOKEN: process.env.STRAPI_TOKEN || '',
  SECRET_KEY_LOACAL_STORAGE: process.env.NEXT_PUBLIC_SECRET_KEY_LOACAL_STORAGE || '',
  DEV_ENV: process.env.NEXT_PUBLIC_DEV_ENV || false
}
